import graphql from './graphql';

const query = /* GraphQL */ `
  query Department_list {
    Department_list {
      id
      name
      status
    }
  }
`;

const DepartmentList = async () => graphql(query).then(data => data.Department_list);

export default DepartmentList;
